<template lang="pug">
div
  screen-title(title="online_booking.trackers_settings_heading")
  .box
    b-field(:label="$t('online_booking.facebook_pixel')" :type="errors.has('facebookPixelId') ? 'is-danger': ''" :message="errors.has('facebookPixelId') ? errors.first('facebookPixelId') : ''")
      b-input(v-model.trim="facebookPixelId" expanded name="facebookPixelId" data-vv-as="Facebook Pixel ID" :placeholder="$t('online_booking.facebook_pixel_placeholder')") 
  .buttons.mt-4
    action-button(title="actions.save" @click="submit" :loading="submitting" permission="ONLINE_BOOKING_SETTINGS_MANAGE" scope)
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'TrackersSettings',

  data() {
    return {
      submitting: false,
      facebookPixelId: undefined
    }
  },
  computed: {
    ...mapState('company', ['company'])
  },
  created() {
    this.facebookPixelId = this.company.facebookPixelId
  },
  methods: {
    async submit() {
      if (this.submitting) return
      this.submitting = true
      const valid = await this.$validator.validateAll()
      if (!valid) {
        this.submitting = false
        return
      }

      const data = {
        facebookPixelId: this.facebookPixelId || ''
      }
      try {
        await this.$store.dispatch('company/update', data)
        this.$buefy.toast.open({message: this.$t('status.save_success'), type: 'is-success', queue: false})
        this.$emit('saved')
      } catch (error) {
        this.$handleAPIError(error)
      }
      this.submitting = false
    }
  }
}
</script>
